import { useState } from "react";
import type { LotGoalFilterFormState } from "../lotGoal.types";
import { LotGoalStatusFilter } from "../utils/lotGoal.utils";

export function useFilterForm() {
  const [filterForm, setFilterForm] = useState<LotGoalFilterFormState>({
    searchText: "",
    status: LotGoalStatusFilter.Active,
  });

  const handleChangeFilter = <T extends keyof LotGoalFilterFormState>(
    field: T,
    value: LotGoalFilterFormState[T]
  ) => {
    setFilterForm((prev) => ({ ...prev, [field]: value }));
  };

  return {
    filterForm,
    handleChangeFilter,
  };
}
